export const ACTION_TYPE = 'actionType';
export const AUDIENCE_ID = 'audienceId';
export const SHOULD_ADD = 'shouldAdd';